<template>
    <div style="width: 800px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
        <div style="color: #005990;">
            <strong>Основы религиозных культур и светской этики</strong>
        </div>
        <div style="font-size: 14px;">
            Так ли необходим этот предмет в школе? Что думают об этом учителя?
        </div>
        <div class="mb-5 mt-4">
            Коллеги, из Министерства образования пришел приказ о новом курсе «Основы религиозных культур и светской этики» для четвероклассников.
            Что вы думаете об уроке?
        </div>

        <div class="title mb-3">Сообщения:</div>
        <div style="">
            <div class="id67-68-69-massage mb-2">
                <div class="mb-2">
                    <strong>Марго44</strong>
                    <span style="float: right">сообщение добавлено только что</span>
                </div>
                <p>
                    Честно, как-то я не могу сказать, что я была сторонницей вначале этого предмета, честно вам говорю, потому что, ну, естественно, новый предмет, новый курс, из-за одного предмета отправляться на большие курсы… Ну, я думаю, что все не особо проявляли к этому интерес, но когда я начала его вести, я поняла, что все-таки это замечательный предмет, и то, что он есть, – это хорошо. Потому что у нас нет другого такого предмета, где мы можем вот такие вещи поднимать, разбирать.
                </p>
            </div>

            <div class="id67-68-69-massage mb-2">
                <div class="mb-2">
                    <strong>Снеговик2931</strong>
                    <span style="float: right">сообщение добавлено 1 минуту назад</span>
                </div>
                <p>
                    Понимаете, это невозможно. Невозможно тем более в четвертом классе, это крайне сложный материал. Мы не должны вторгаться в жизнь школьников и профанировать идею светского образования! Все это – большая чепуха!
                </p>
            </div>

            <div class="id67-68-69-massage mb-2">
                <div class="mb-2">
                    <strong>Евгения1975</strong>
                    <span style="float: right">сообщение добавлено 1 минуту назад</span>
                </div>
                <p>
                    Почему вы так разгневаны? Изучите внимательней учебник, он абсолютно ценностно-нейтрален. Это всего лишь культурологический курс. Жить в России и не знать культуру своего народа – это стыдно.
                </p>
            </div>

            <div class="id67-68-69-massage mb-2">
                <div class="mb-2">
                    <strong>Пушинк@</strong>
                    <span style="float: right">сообщение добавлено 2 минуты назад</span>
                </div>
                <p>
                    Думаю, что четвертые классы маловаты для культур религиозных. Я бы лично делала это бы только в старшей школе. Как завидовал 11-й класс, увидев: ой, какие учебники, ой, нам бы. Вот именно, им бы, потому что у них готовое сложилось какое-то мнение, зачем мы будем торопиться с мнением? Это прежде всего семейное дело – религии. Светская этика – другое, светская этика – это общие правила поведения, а это что? Спешим, ох, спешим.
                </p>
            </div>

            <div class="id67-68-69-massage mb-2">
                <div class="mb-2">
                    <strong>Бондарев И.О.</strong>
                    <span style="float: right">сообщение добавлено 3 минуты назад</span>
                </div>
                <p>
                    Считаю, что это антиконституционно. У каждого человека есть право на умолчания своего вероисповедания, к чему этот курс в школе? Кажется, наше государство уже достаточно независимо от церкви, чтобы реализовывать образовательную политику самостоятельно. В общем, это была последняя капля, я ухожу из школы. Коллеги, удачи и терпения!
                </p>
            </div>

            <div class="id67-68-69-massage mb-2">
                <div class="mb-2">
                    <strong>Кентуки000</strong>
                    <span style="float: right">сообщение добавлено 5 минут назад</span>
                </div>
                <p>
                    Мои родители – военного поколения, мои учителя – военного поколения, какое право я имею об этом забыть? Только сейчас у нас реальная есть возможность действительно осуществлять то, что мы называем свободой совести, сейчас это работает. Этого не было, естественно, в царской России, когда навязывалось православие, этого не было в советское время, когда навязывался атеизм. Сейчас ничего не навязывается – пожалуйста, полная свобода выбора, ради бога. Но при любом раскладе люди должны быть людьми, и светская этика этому всецело способствует, слава богу.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {}
</script>
<style scoped>
    .id67-68-69-massage {
        display: inline-block;
        border-radius: 12px;
        text-align: left;
        padding: 12px 15px;
        background-color: #e7e7e7;
        font-size: 14px;
        width: 70%;
    }
</style>